"use strict";

define('view/message.template/message.template.list',['require','exports','module','marionette','uikit/uikit','view/table.card','libs/format/template','libs/route.helper','templates','langs'],function (require, exports, module) {
  var Mn = require('marionette');
  var UIKit = require('uikit/uikit');
  var TableCard = require('view/table.card');
  var TemplateFormatter = require('libs/format/template');
  var RouteHelper = require('libs/route.helper');
  var Templates = require('templates');
  var langs = require('langs');
  var COLUMNS = [{
    text: 'Description',
    data: 'code.description'
  }, {
    text: 'Status',
    data: 'override',
    formatter: TemplateFormatter(Templates.IRB['message.template.status']),
    width: '30%'
  }];
  var Cards = Mn.CollectionView.extend({
    childView: TableCard,
    childViewEventPrefix: 'card',
    childViewOptions: function childViewOptions() {
      return {
        columns: COLUMNS,
        headerAriaLevel: '3'
      };
    }
  });
  var MessageTemplateListView = UIKit.Container.extend({
    options: {
      openTabIndex: -1
    },
    update: {
      openTabIndex: false
    },
    initialize: function initialize() {
      UIKit.Container.prototype.initialize.apply(this, arguments);
      this.sectionHeader = new UIKit.Header({
        text: langs.phrase('Settings.MessageTemplates.List.Title'),
        tagName: 'h2',
        className: UIKit.Header.prototype.className + ' accessibility-text'
      });
      this.tabs = new UIKit.Tabs({
        tabListAriaLabel: langs.phrase('Settings.MessageTemplates.List.Tabs.ARIALabel'),
        attached: false
      }).on('change:openTabIndex', function () {
        this.openTabIndex = this.tabs.openTabIndex;
      }, this);
      this.tabs.menu.tabular = false;
      this.tabs.menu.color = 'dark';
      this.tabs.menu.fluid = true;
      this.add(this.sectionHeader);
      this.add(this.tabs);
      this.configureTabContent();
    },
    onChangeOpenTabIndex: function onChangeOpenTabIndex() {
      this.tabs.openTabIndex = this.openTabIndex;
    },
    configureCardTable: function configureCardTable(table) {
      table.rowLinkFormatter = RouteHelper.linkFormatGenerator('messageTemplate:detail', {
        messageTemplateId: 'id'
      });
    },
    configureTabContent: function configureTabContent() {
      var emailMessages = new Cards({
          collection: new Backbone.Collection([])
        }).on('before:add:child', function (view) {
          this.configureCardTable(view.table);
        }, this),
        notificationMessages = new Cards({
          collection: new Backbone.Collection([])
        }).on('before:add:child', function (view) {
          this.configureCardTable(view.table);
        }, this);
      this.tabs.add('Emails', emailMessages, _.bind(this.configureTabItem, this));
      this.tabs.add('Notifications', notificationMessages, _.bind(this.configureTabItem, this));
    },
    getTabByName: function getTabByName(tabName) {
      switch (tabName) {
        case 'emails':
          return this.tabs.at(0);
        case 'notifications':
          return this.tabs.at(1);
        default:
          throw new Error(tabName + ' is not a valid tab name.');
      }
    },
    setTabData: function setTabData(tabName, data) {
      var tab = this.getTabByName(tabName),
        cardArray = [];
      _.chain(data).groupBy(function (a) {
        return a.get('code').get('notificationKind').get('description');
      }).each(function (list, key) {
        cardArray.push(new Backbone.Model({
          header: key,
          collection: new Backbone.Collection(list)
        }));
      });
      tab.content.collection.reset(cardArray);
    },
    configureTabItem: function configureTabItem(tabItem) {
      tabItem.attached = false;
      tabItem.fitted = true;
      tabItem.basic = true;
    }
  });
  module.exports = MessageTemplateListView;
});

